
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, Button } from '@mui/material';
import React, { useEffect, useState } from 'react';
import orologo from "../Image/oro-logo.jpeg";
import mpcst from "../Image/newmpcst-logo.jpg";
import { Link } from 'react-router-dom';
import Adminsidebar from './Adminsidebar';
import DesktopFooter from "../Component/Desktopfooter";
import axios from 'axios';

function createData( phone, age, ) {
    return {  phone , age,  };
  }
  
  const Admintable = () => {
    const [rows, setRows] = useState([]);

    useEffect(() => {
      fetchUsers();
    }, []);
  
    const fetchUsers = async () => {
      try {
        const res = await axios.get('/api/getusers'); // adjust endpoint
        setRows(res.data);
      } catch (err) {
        console.error('Error fetching users:', err);
      }
    };
    return (
      <>
          <div className="app-header-wrapper">
      
                <div className="header-logo">
                  <img src={orologo} alt="logo" />
                </div>
      
                <div className="header-text">
                    <Typography variant="h4" sx={{ textTransform: "uppercase" }}>
                    Orocancer Watch
                  </Typography>
                  <Typography variant="body1" sx={{ textTransform: "uppercase" }}>
                    All India Institute of Medical Sciences, Bhopal
                  </Typography>
                </div>
      
                <div className="header-logo">
                  <img src={mpcst} alt="logo" />
                </div>
                </div>
        <div className='admin-dashoardpanel'>
          <Adminsidebar />
          <div className='customdatatable-wrapper'>
            <div className='dashboard-header'>
              <Typography variant='h2'>Dashboard</Typography>
            </div>
  
            <div className='tiles-filter-wrapper'>
              <Link className='download' to="#">
                Download all
              </Link>
  
              <TableContainer component={Paper}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>S.No</TableCell>
                      <TableCell>Phone No.</TableCell>
                      <TableCell>Total Attempts</TableCell>
                      <TableCell>Latest Attempt</TableCell>
                      <TableCell>Action</TableCell>
                    </TableRow>
                  </TableHead>
  
                  <TableBody>
                    {rows.map((row) => (
                      <TableRow key={row.id}>
                        <TableCell>{row.id}</TableCell>
                        <TableCell>{row.user_number}</TableCell>
                        <TableCell>{row.attempt_no}</TableCell>
                        <TableCell>{row.last_attempt}</TableCell>
                        <TableCell>
                          <Button
                            variant="contained"
                            size="small"
                            component={Link}
                            to={`/user/${row.id}`}
                          >
                            View
                          </Button>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
  
                </Table>
              </TableContainer>
            </div>
          </div>
        </div>
         <DesktopFooter/>
      </>
    );
  };

  export default Admintable